import { render } from "./AdminNavItem.vue?vue&type=template&id=4294f869"
import script from "./AdminNavItem.vue?vue&type=script&lang=js"
export * from "./AdminNavItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__